import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate, useSearchParams } from "react-router-dom";
import { storiesRoute } from "../../routes/routesPath";
import { getFilters } from "../../utils/helpers";
import { defaultPage, limitOptions, sortingOptions } from "../../utils/constants";
import { savedStoriesListingFilters } from "../../utils/filters";
import { handleApiRequest } from "../../services/handleApiRequest";
import { getBookmarksList } from "../../redux/bookmarks/thunk";
import AskToShare from "../../Component/askToShare";
import ReactionsListsPop from "../../Component/Modals/reactionsListPop";
import LoadIndicator from "../../Component/Loader";
import StoryCard from "../../Component/storyCard/mainStoryCard";
import MySelect from "../../Component/common/mySelect";
import MyPagination from "../../Component/common/pagination";
import CardSkeleton from "../../Component/skeleton/cardSkeleton";
import FeelingsFilter from "../../Component/common/filters/feelingsFilter";
import SortingDropdown from "../../Component/common/filters/sortingDropdown";
import MyHelmet from "../../seo/helmet";

export default function BookmarkedStories() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const selectedFilters = Object.fromEntries(searchParams.entries());

  const { loadingBookmarksList = false, bookmarksList = {} } = useSelector(
    (state) => state.bookmarks
  );

  const [userAction, setUserAction] = useState(null);
  const [paginationDetails, setPaginationDetails] = useState(defaultPage);
  const [showReaction, setShowReaction] = useState("");

  const handleLimit = (selected) => {
    setPaginationDetails((prev) => ({ ...prev, limit: selected }));
  };

  const handleStories = async () => {
    const filters = await getFilters(savedStoriesListingFilters, selectedFilters);

    await handleApiRequest(getBookmarksList, filters);
  };

  useEffect(() => {
    handleStories();
  }, [searchParams]);

  return (
    <>
      <MyHelmet title={"Save the story that you like"} keywords="" description="" />

      <div className="w-100 overflow-auto">
        {bookmarksList.totalCount > 0 && (
          <div
            className={`${
              loadingBookmarksList ? "" : "hide-loader"
            } d-flex align-items-center justify-content-center`}>
            <LoadIndicator />
          </div>
        )}

        <div className="storyFilters d-flex align-items-center justify-content-start gap-2 p-3 px-lg-5">
          <SortingDropdown sortingOptions={sortingOptions.slice(1)} />
          <FeelingsFilter className="pe-2" />
        </div>

        {bookmarksList?.totalCount === 0 ? (
          <div className="text-center my-4">
            <h3 className="m-0">Save stories those you like...</h3>
            <img src="/images/noStories.png" alt="Save stories" className="max-w-400 w-100" />
            <h4 className="text-uppercase">Save your first story</h4>
            <button className="primaryBtn rounded px-3 py-2" onClick={() => navigate(storiesRoute)}>
              View Stories
            </button>
          </div>
        ) : (
          <div className={`px-3 px-lg-5 pt-3`}>
            {bookmarksList.totalCount > 0 ? (
              <>
                {bookmarksList.records?.map((story, i) => (
                  <StoryCard
                    key={story._id}
                    story={story}
                    showReaction={showReaction}
                    setShowReaction={setShowReaction}
                  />
                ))}
                <div className="d-flex justify-content-between py-3">
                  <div>
                    <MySelect
                      classNamePrefix={"mySelect"}
                      options={limitOptions}
                      isSearchable={false}
                      value={paginationDetails.limit}
                      onChange={(selected) => handleLimit(selected)}
                    />
                  </div>
                  <MyPagination
                    paginationDetails={paginationDetails}
                    setPaginationDetails={setPaginationDetails}
                    totalCount={bookmarksList.totalCount}
                    darkPagination={true}
                  />
                </div>
              </>
            ) : (
              Array.from({ length: 3 }).map((_) => <CardSkeleton />)
            )}
          </div>
        )}
        <div className="curvatureContainer">
          <div>
            <div id="curved-corner-topright" />
          </div>
          <div>
            <div id="curved-corner-topleft" />
          </div>
        </div>

        <AskToShare />
      </div>
      {userAction?.action === "showReactionsList" && (
        <ReactionsListsPop userAction={userAction} setUserAction={setUserAction} />
      )}
    </>
  );
}
